module.exports = __webpack_public_path__ + "static/media/homepage-section-2-mobile-app.c670d2fa.png";